import React, { useState, useRef } from "react";
import { getUserInfo, removeUserInfo, saveUserInfo } from "utils/localStorage";
import { uploadAvatar } from "api/User.api";
import "./style.scss";

const ProfilePage = () => {
  const userInfo = getUserInfo();
  const [profile, setProfile] = useState({
    name: userInfo?.data.displayName || "User Name",
    email: userInfo?.data.email || "User Email",
    avatar: userInfo?.data.avatarUrl || "/default-avatar.jpeg",
  });

  const [isEditing, setIsEditing] = useState(false); // trạng thái đang chỉnh sửa avatar
  const [tempAvatar, setTempAvatar] = useState(null); // avatar tạm khi chọn file mới (chưa lưu)
  const [selectedFile, setSelectedFile] = useState(null); // store the selected file for upload
  const fileInputRef = useRef(null);

  // Mở hộp chọn file
  const handleEditClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  // Khi chọn file avatar mới, cập nhật ảnh tạm
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const url = URL.createObjectURL(file);
      setTempAvatar(url);
      setSelectedFile(file);
      setIsEditing(true);
    }
  };

  // Lưu ảnh avatar đã chọn
  const handleSaveClick = async () => {
    if (selectedFile) {
      try {
        const formData = new FormData();
        formData.append("avatar", selectedFile);

        const response = await uploadAvatar(formData);
        if (response && response.avatarUrl) {
          setProfile({ ...profile, avatar: response.avatarUrl });
          setTempAvatar(null);
          setSelectedFile(null);
          setIsEditing(false);

          const userInfo = await getUserInfo();
          removeUserInfo()
          
          // Save the user information to localStorage
          saveUserInfo(userInfo);
        }
      } catch (error) {
        console.error("Failed to upload avatar:", error);
        // Optionally show error to user
      }
    }
  };

  // Hủy chỉnh sửa avatar
  const handleCancelClick = () => {
    setTempAvatar(null);
    setSelectedFile(null);
    setIsEditing(false);
  };

  // Xóa avatar về mặc định
  const handleDeleteClick = () => {
    setProfile({ ...profile, avatar: "/default-avatar.jpeg" });
    setTempAvatar(null);
    setSelectedFile(null);
    setIsEditing(false);
  };

  return (
    <div className="profile-container">
      <div className="profile-avatar">
        <img src={tempAvatar || profile.avatar} alt="Avatar" />
        
        {!isEditing && (
          <button className="edit-btn" onClick={handleEditClick}>Edit</button>
        )}

        {isEditing && (
          <div className="save-cancel-buttons">
            <button className="save-btn" onClick={handleSaveClick}>Save</button>
            <button className="cancel-btn" onClick={handleCancelClick}>Cancel</button>
            <button className="delete-btn" onClick={handleDeleteClick}>Delete</button>
          </div>
        )}

        <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          style={{ display: "none" }}
          onChange={handleFileChange}
        />
      </div>

      <div className="profile-info">
        <h2>Public profile</h2>
        <div className="form-group">
          <label>Name</label>
          <input
            type="text"
            placeholder="Your name"
            value={profile.name}
            onChange={(e) => setProfile({ ...profile, name: e.target.value })}
          />
          <small>Your name may appear around the site where you contribute or are mentioned.</small>
        </div>

        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            placeholder="Your email"
            value={profile.email}
          />
        </div>
      </div>
    </div>
  );
};

export default React.memo(ProfilePage);
